import { render } from "./InquiryForm.vue?vue&type=template&id=39c87a33&ts=true"
import script from "./InquiryForm.ts?vue&type=script&lang=ts&external"
export * from "./InquiryForm.ts?vue&type=script&lang=ts&external"

import "./InquiryForm.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__